import { render } from "./buttonDarkBig.vue?vue&type=template&id=c7da0158"
import script from "./buttonDarkBig.vue?vue&type=script&lang=js"
export * from "./buttonDarkBig.vue?vue&type=script&lang=js"

import "./buttonDarkBig.vue?vue&type=style&index=0&id=c7da0158&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__